// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 60868 ? "auth-suite-sdk" : chunkId) + "-" + {"20758":"1a57832ee56a5aa9e6e0","22550":"8f577fa85b40b742f234","37497":"6b0dceba58b2c6518c04","44139":"1f10d6095dcca8e844e5","60819":"0e63a2f633411cce0253","60868":"a8760008217b83525621","96373":"283b26a2d79cd57949b5"}[chunkId] + ".min.js";
};